import { Checkbox, DataSource, Image, Label, Layout, Panel, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutPlanningLinkedMoves extends Layout {
    checkboxLinkAll: Checkbox;
    imageInstructionalIcon: Image;
    labelHideUnlinked: Label;
    labelInstructionManageP1: Label;
    labelInstructionManageP2: Label;
    labelLinkPrompt: Label;
    panelActions: Panel;
    panelHideLinkMoves: Panel;
    sourceAvailableMove: DataSource;
    sourcePlanningMovementStops: DataSource;
    switchHideUnlinked: Switch;
    tableEquipmentAssignments: Table;
}
